import React from "react";
import PropTypes from "prop-types";
import Waypoint from "react-waypoint";

class Ad extends React.Component {
  static propTypes = {
    adUnitPath: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    sizeMapping: PropTypes.array.isRequired,
    targeting: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.id = `ad-instance-${props.id}`;
    this.adSlot = null;
    this.displayAd = this.displayAd.bind(this);
  }

  componentDidMount() {
    const { adUnitPath, sizeMapping, targeting } = this.props;

    googletag.cmd.push(() => {
      // Set ad dimensions
      const sizeMappingArray = sizeMapping
        .reduce(
          (mapping, size) => mapping.addSize(size.viewport, size.slot),
          googletag.sizeMapping(),
        )
        .build();

      // Define the ad slot
      this.adslot = googletag
        .defineSlot(adUnitPath, sizeMapping[0].slot, this.id)
        .defineSizeMapping(sizeMappingArray);

      // Set targets
      Object.keys(targeting).forEach(key => this.adslot.setTargeting(key, targeting[key]));

      // Add pubads service
      this.adslot.addService(googletag.pubads());

      // Start ad fetching
      googletag.enableServices();
    });
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    googletag.cmd.push(() => {
      googletag.destroySlots([this.adslot]);
    });
  }

  displayAd() {
    googletag.cmd.push(() => {
      googletag.display(this.id);
    });
  }

  render() {
    return (
      <div>
        <Waypoint onEnter={this.displayAd} />
        <div id={this.id} />
      </div>
    );
  }
}

export default Ad;



// WEBPACK FOOTER //
// ./assets/shared/components/ad.jsx